import { TrailerClient } from '@src/trailer/service/TrailerClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Props {
  clientId: string;
  trailerId: string;
  onSuccess: () => void;
  onError: () => void;
}

export const useDeleteTrailer = ({
  clientId,
  trailerId,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: async () => {
      await TrailerClient.delete(clientId, trailerId);
    },
    onSuccess: async () => {
      onSuccess();
      await queryClient.invalidateQueries({
        queryKey: ['trailers.list', clientId],
      });
    },
    onError,
  });

  return {
    deleteTrailer: mutate,
    isLoading: isPending,
  };
};
